import type { TagSheetSaveResult } from '../../types';
import { isAdSuccessfullyCreated, isCreativeSuccessfullyCreated } from '../../utils/createAdsWithCreativesOutcome';

type SummaryCount = {
  successCount: number;
  totalCount: number;
};

export type ResultsSummaryData = {
  adSummary: SummaryCount;
  creativeSummary: SummaryCount;
};

export const getSummary = (lineItems: TagSheetSaveResult['lineItems']): ResultsSummaryData => {
  let adSuccessCount = 0;
  let adTotalCount = 0;
  let creativeSuccessCount = 0;
  let creativeTotalCount = 0;
  const seenSuccessfulCreativeIds = new Set<string>();

  for (const lineItem of lineItems) {
    for (const adItem of lineItem.ads) {
      adTotalCount += 1;

      if (isAdSuccessfullyCreated(adItem)) {
        adSuccessCount += 1;
      }

      const creativeItem = adItem.creativeEntity;

      if (!isCreativeSuccessfullyCreated(creativeItem)) {
        creativeTotalCount += 1;
        continue;
      }

      const { creativeEntity } = creativeItem;
      const creativeId = 'id' in creativeEntity ? creativeEntity.id : '';

      if (!creativeId || seenSuccessfulCreativeIds.has(creativeId)) {
        continue;
      }

      seenSuccessfulCreativeIds.add(creativeId);
      creativeTotalCount += 1;
      creativeSuccessCount += 1;
    }
  }

  return {
    adSummary: { successCount: adSuccessCount, totalCount: adTotalCount },
    creativeSummary: { successCount: creativeSuccessCount, totalCount: creativeTotalCount },
  };
};
